import { render, staticRenderFns } from "./addContentDialog.vue?vue&type=template&id=fcfdbc24&scoped=true"
import script from "./addContentDialog.vue?vue&type=script&lang=js"
export * from "./addContentDialog.vue?vue&type=script&lang=js"
import style0 from "./addContentDialog.vue?vue&type=style&index=0&id=fcfdbc24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfdbc24",
  null
  
)

export default component.exports